// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const emso: CountryValidator<"SI", ParsedPersonId> =
  createValidator("si.emso", 158);

export default emso;
export const compact = emso.compact;
export const format = emso.format;
export const validate = emso.validate;
export const generate = (): string =>
  emso.generate?.() ??
  (() => {
    throw new Error(
      "Validator si.emso cannot generate values",
    );
  })();
export const parse = emso.parse;
